import { documentId, limit, query, where } from 'firebase/firestore'
import type { MedicineArticle } from '~/models'
import { ArrayService } from './serviceLive'

export class MedicineArticleService extends ArrayService<MedicineArticle> {
  constructor() {
    super('MedicineArticles')
  }

  public listenForArticleNumber(articleNumber: number): void {
    const start
      = articleNumber * Math.pow(10, 8 - articleNumber.toString().length)

    const end
      = (articleNumber + 1) * Math.pow(10, 8 - articleNumber.toString().length)
        - 1

    const listenQuery = query(
      this.collection,
      where('ArticleNumber', '>=', start),
      where('ArticleNumber', '<=', end),
      limit(50),
    )
    this.listen(listenQuery)
  }

  public listenForArticleName(articleName: string): void {
    const words = articleName.split(' ').map(word => word.toLowerCase())

    if (words[0] === '') {
      return
    }

    const listenQuery = query(
      this.collection,
      where('AllSearchTerms', 'array-contains', words[0]),
      limit(50),
    )
    this.listen(listenQuery)
  }

  public listenForArticleIds(articleIds: string[]): void {
    const batchSize = this.MAX_IN_CLAUSE

    for (let i = 0; i < articleIds.length; i += batchSize) {
      const batch = articleIds.slice(i, i + batchSize)
      const listenQuery = query(
        this.collection,
        where(documentId(), 'in', batch),
      )
      this.listen(listenQuery)
    }
  }

  public listenForArticleNumbers(articleNumbers: number[]): void {
    const batchSize = this.MAX_IN_CLAUSE

    for (let i = 0; i < articleNumbers.length; i += batchSize) {
      const batch = articleNumbers.slice(i, i + batchSize)
      const listenQuery = query(
        this.collection,
        where('ArticleNumber', 'in', batch),
      )
      this.listen(listenQuery)
    }
  }
}
